// extracted by mini-css-extract-plugin
export default {"header":"ScrollTable_header__-QVGj","scrolled":"ScrollTable_scrolled__tDcPw"};